/**
 * Rental API - GL-BE-001
 * Endpoints: GET /rentals/leases, GET /rentals/applications
 */

import { apiGetWithFallback } from './api-response';
import { Lease, TenantApplication } from '../types/lease';

export async function getLeases(): Promise<Lease[]> {
  const data = await apiGetWithFallback<{ leases: Lease[] }>('/rentals/leases', { leases: [] });
  return data.leases ?? [];
}

export async function getApplications(): Promise<TenantApplication[]> {
  const data = await apiGetWithFallback<{ applications: TenantApplication[] }>('/rentals/applications', { applications: [] });
  return data.applications ?? [];
}
